module.exports = __webpack_public_path__ + "system/img/file.36c1c089.png";